export const AddPeopleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2617_18142)">
      <path d="M6.66667 8.33335H4.16667V5.83335H2.5V8.33335H0V10H2.5V12.5H4.16667V10H6.66667V8.33335ZM15 9.16669C16.3833 9.16669 17.4917 8.05002 17.4917 6.66669C17.4917 5.28335 16.3833 4.16669 15 4.16669C14.7333 4.16669 14.475 4.20835 14.2417 4.28335C14.7167 4.95835 14.9917 5.77502 14.9917 6.66669C14.9917 7.55835 14.7083 8.36669 14.2417 9.05002C14.475 9.12502 14.7333 9.16669 15 9.16669ZM10.8333 9.16669C12.2167 9.16669 13.325 8.05002 13.325 6.66669C13.325 5.28335 12.2167 4.16669 10.8333 4.16669C9.45 4.16669 8.33333 5.28335 8.33333 6.66669C8.33333 8.05002 9.45 9.16669 10.8333 9.16669ZM16.35 10.9667C17.0417 11.575 17.5 12.35 17.5 13.3334V15H20V13.3334C20 12.05 18.025 11.2584 16.35 10.9667ZM10.8333 10.8334C9.16667 10.8334 5.83333 11.6667 5.83333 13.3334V15H15.8333V13.3334C15.8333 11.6667 12.5 10.8334 10.8333 10.8334Z" />
    </g>
    <defs>
      <clipPath id="clip0_2617_18142">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
